<div class="popup" *ngIf="isVisibleDetails">
  <div class="panelDetailGeofences" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
    <loading [isLoading]="isLoading"></loading>

    <div class="details-flex">

      <div class="arrow-container">
        <!-- Botón regresar-->
        <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>
        
          <mat-icon *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>

          <!-- boton cerrar -->
        <!-- <div class="btnClose">
          <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
        </div> -->
      </div>

      <!-- Primera sección -->
      <div class="header_panel">

          <!-- Encabezado -->
          <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
              <img src="/assets/img/icon_geofence_on.png" class="img-car" />
          </div>

          <!-- VIN-->
          <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
            <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
            <label class="titlePanel vin-title"> {{ this.Title }}</label>
            
            <label *ngIf="!mobileQuery.matches" class="header-text-label">Guid</label>
            <label *ngIf="!mobileQuery.matches" class="subtitlePanel"> {{this.Guid}}</label>
        </div>

          <!-- Componente de lista de reportes -->
         <!-- <div class="btnMenuSecondary">
          <app-report-list [reportes]="false" [editGeofences]="true" [isGeofenceDetails]="true" [geofenceGuid]="this.Guid" ></app-report-list>
         </div> -->
      </div>

      <div class="button-tool-list" id="panelDetailGeofencesTool">
        <div class="col-10">
          <location-button-toolbar [reportes]="false" [isGeofenceDetails]="true" [geofenceGuid]="this.Guid"></location-button-toolbar>
        </div>
    
        <div class="col-2">
          <!-- <div class="tool-option" >
            <app-report-list [reportes]="false" [editGeofences]="true" [isGeofenceDetails]="true" [geofenceGuid]="this.Guid" ></app-report-list>
          </div> -->
        </div>
      </div>
        
      <div class="geofences-data-scroll-container" id="panelDetailGeofencesData">
        <!-- segunda seccion -->
        <div class="details-section">
          <div class="row text-header">
            <div class="section-header-background">
              <h3>Detalle de Geocerca</h3>
            </div>
          </div>

          <div *ngFor="let key of Keys">
            <div *ngIf="!key.startsWith('_') && !(key == 'Radio' || key == 'Identifiers' || key == 'Nombre')" class="row row-data detail-items">
            
              <div class="titlePanel">{{ key }}</div>

              <div class="col-12 d-flex general-data">
                <div>{{ Values[Keys.indexOf(key)] }}</div>
              </div>

            </div>
          </div>

        </div>
        
        <!-- Tercera sección -->
        <div class="identifier-section">
          <div class="row text-header">
            <div class="section-header-background">
              <h3>Identificadores ({{ identifiers.length }})</h3>
            </div>
          </div>
        
          <div class="row identifier-list">
            <div *ngFor="let identifier of identifiers">
              <div *ngIf="identifier != ''" class="row row-data detail-items">
                <div class="col-11 d-flex align-items-center justify-content-center">
                  <label>{{ identifier }} </label>
                </div>
                <!-- <div class="col-7 d-flex align-items-center general-data">
                  <div>{{  }}</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>  

    <div class="">
      <div class="section-footer-background">
      </div>
    </div>
  </div>
</div>